import snaptr from "web/script/embedded/snapchat";

export default {
    pixelId: "9f5e7498-5439-46d3-8e95-a582cdb727aa",

    /**
     * @param {Analytics} analytics The parent analytics module
     */
    init: function(analytics) {
        var snapchatHash = analytics.getSnapchatHash();
        snaptr("init", this.pixelId, { user_hashed_email: snapchatHash });
    },

    send: function(data) {
        data.forEach((event) => {
            if (event.type === "page_view") {
                snaptr("track", "PAGE_VIEW");
            }
        });
        return Promise.resolve();
    },
};
